function userStartedStreamInitLessonAdapter(data) {
  const {
    name,
    fullName,
    userId,
    user_id: userIdSnakeCase,
    id,
    isTeacher,
    is_teacher: isTeacherSnakeCase,
  } = data;

  return {
    ...data,
    name: name || fullName || 'Неизвестное имя',
    userId: userId ?? userIdSnakeCase ?? id ?? null,
    isTeacher: isTeacher ?? isTeacherSnakeCase ?? false,
    adapted: true,
  };
}

export default userStartedStreamInitLessonAdapter;
